// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-workbook-entries-table__table {
  display: table;
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
}
.dl-workbook-entries-table__header {
  display: table-header-group;
}
.dl-workbook-entries-table__header-row {
  display: table-row;
}
.dl-workbook-entries-table__header-cell_empty {
  border: none;
}
.dl-workbook-entries-table__header-cell {
  display: table-cell;
  box-sizing: content-box;
  overflow: hidden;
  overflow-wrap: break-word;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  padding: 0 10px;
  border-bottom: 1px solid var(--g-color-line-generic);
}
.dl-workbook-entries-table__header-cell_author {
  width: 165px;
}
.dl-workbook-entries-table__header-cell_date {
  width: 150px;
}
.dl-workbook-entries-table__header-cell_controls {
  width: 100px;
}
.dl-workbook-entries-table__header-cell {
  font-family: var(--g-text-subheader-font-family);
  font-weight: var(--g-text-subheader-font-weight);
  font-size: var(--g-text-subheader-1-font-size);
  line-height: var(--g-text-subheader-1-line-height);
  color: var(--g-color-text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/ui/units/workbooks/components/Table/WorkbookEntriesTable/WorkbookEntriesTable.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAGI;EACI,cAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAFR;AAKI;EACI,2BAAA;AAHR;AAMI;EACI,kBAAA;AAJR;AAOI;EACI,YAAA;AALR;AAQI;EACI,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,oDAAA;AANR;AAQQ;EACI,YAAA;AANZ;AASQ;EACI,YAAA;AAPZ;AAUQ;EACI,YAAA;AARZ;AAYI;ECgLA,gDAAA;EACA,gDAAA;EACA,8CAAA;EACA,kDAAA;EDjLI,oCAAA;AAPR","sourcesContent":[".dl-workbook-entries-table__table {\n  display: table;\n  width: 100%;\n  max-width: 100%;\n  table-layout: fixed;\n}\n.dl-workbook-entries-table__header {\n  display: table-header-group;\n}\n.dl-workbook-entries-table__header-row {\n  display: table-row;\n}\n.dl-workbook-entries-table__header-cell_empty {\n  border: none;\n}\n.dl-workbook-entries-table__header-cell {\n  display: table-cell;\n  box-sizing: content-box;\n  overflow: hidden;\n  overflow-wrap: break-word;\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: middle;\n  padding: 0 10px;\n  border-bottom: 1px solid var(--g-color-line-generic);\n}\n.dl-workbook-entries-table__header-cell_author {\n  width: 165px;\n}\n.dl-workbook-entries-table__header-cell_date {\n  width: 150px;\n}\n.dl-workbook-entries-table__header-cell_controls {\n  width: 100px;\n}\n.dl-workbook-entries-table__header-cell {\n  font-family: var(--g-text-subheader-font-family);\n  font-weight: var(--g-text-subheader-font-weight);\n  font-size: var(--g-text-subheader-1-font-size);\n  line-height: var(--g-text-subheader-1-line-height);\n  color: var(--g-color-text-secondary);\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
